import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "value", "className", "autoWidth", "onChange", "IconComponent"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState } from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import { Select } from '@mui/material';
import { EmbersMenuItem } from '../../../../menuItem/menuItem';
import { resultsPerPageSelectTheme } from './resultsPerPageSelectStyles';
export var ResultsPerPageSelect = function ResultsPerPageSelect(_ref) {
  var options = _ref.options,
    value = _ref.value,
    className = _ref.className,
    _ref$autoWidth = _ref.autoWidth,
    autoWidth = _ref$autoWidth === void 0 ? true : _ref$autoWidth,
    onChange = _ref.onChange,
    IconComponent = _ref.IconComponent,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    _value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    focusedByClick = _useState6[0],
    setFocusedByClick = _useState6[1];
  var handleChange = function handleChange(e) {
    var val = Number(e.target.value);
    setValue(val);
    onChange === null || onChange === void 0 || onChange(val);
  };
  var arrowIcon = function arrowIcon() {
    return /*#__PURE__*/React.createElement("span", {
      className: classnames('icon-expand-more', {
        'is-open': open
      })
    });
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: resultsPerPageSelectTheme
  }, /*#__PURE__*/React.createElement(Select, _extends({
    value: _value,
    onChange: handleChange,
    className: classnames('EmbersBasicSelect-root', {
      'EmbersBasicSelect-focused-by-click': focusedByClick
    }, className),
    autoWidth: autoWidth,
    IconComponent: IconComponent || arrowIcon,
    onOpen: function onOpen(e) {
      if (e.type === 'mousedown') {
        setFocusedByClick(true);
      }
      setOpen(true);
    },
    MenuProps: {
      transitionDuration: 30
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    onBlur: function onBlur(e) {
      if (e.type === 'blur') {
        setFocusedByClick(false);
      }
    }
  }, otherProps), options.map(function (o) {
    return /*#__PURE__*/React.createElement(EmbersMenuItem, {
      value: o.toString(),
      key: o.toString()
    }, o);
  })));
};